/* eslint-disable indent,linebreak-style */
/**
 * Created by charnjeetelectrovese@gmail.com on 9/15/2017.
 */
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
// import UserReducer from './users.reducers';
import AuthReducer from './Auth.reducer';
import User from './User.reducer';
import Customers from './Customers.reducer';
import DashboardReducer from './Dashboard.reducer';
import AppSettingReducer from './AppSettings.reducer';
import SupportReducer from './Support.reducer';
import Countries from './CountriesInfo.reducer';
import Cities from './CitiesInfo.reducer';
import Category from './Category.reducer'
import Subcategory from './SubCategory.reducer'
import Template from './Template.reducer'
import ProviderUser from './ProviderUser.reducer';
import Projects from './Projects.reducer';
import UserProfile from './UserProfile.reducer'
import GalleryImageReducer from './GalleryImage.reducer';
import Spotlites from './Spotlites.reducer';
import Jobs from './Jobs.reducer';
import Language from './Language.reducer';
import Banner from './Banner.reducer'
import Dispute from './Dispute.reducer';
import Payments from './Payment.reducer';
import Payouts from './Payout.reducer';
import JobReport from './JobReport.reducer';
import Reviews from './Reviews.reducer';
import UserReport from './UserReport.reducer';
import CurrencyReducer from './Currency.reducer';
import SpecialDealsReducer from './SpecialDeal.reducer';
import UserDealsReducer from './UserDeal.reducer'

const rootReducer = combineReducers({
    state: (state = {}) => state,
    form: formReducer,
    app_setting: AppSettingReducer,
    dashboard: DashboardReducer,
    gallery_image: GalleryImageReducer,
    user: User,
    auth: AuthReducer,
    category: Category,
    customers: Customers,
    support: SupportReducer,
    subcategory: Subcategory,
    template: Template,
    provider_user: ProviderUser,
    projects: Projects,
    user_profile: UserProfile,
    countries: Countries,
    cities: Cities,
    spotlites: Spotlites,
    jobs: Jobs,
    banner : Banner,
    language: Language,
    payments: Payments,
    payouts: Payouts,
    job_report: JobReport,
    user_report: UserReport,
    reviews: Reviews,
    dispute: Dispute,
    currency: CurrencyReducer,
    user_deals: UserDealsReducer,
    special_deals: SpecialDealsReducer,
    // form: formReducer,
});

export default rootReducer;
